<template>
    <div v-if="sources.length" class="draft-sources">
        <ul class="list-unstyled mb-1">
            <li
                v-for="(s, idx) in sources"
                :key="s.storage_id || `${s.filename}-${idx}`"
                class="d-flex align-items-center mb-1"
            >
                <span class="text-truncate mr-2" :title="s.filename">{{ s.filename }}</span>
                <b-badge
                    v-if="s.status === 'used'"
                    variant="success"
                    class="mr-1 flex-shrink-0"
                >
                    반영됨
                </b-badge>
                <b-badge
                    v-else
                    variant="secondary"
                    class="mr-1 flex-shrink-0"
                >
                    반영 안 됨
                </b-badge>
                <b-badge
                    v-if="s.partial"
                    variant="warning"
                    class="mr-1 flex-shrink-0"
                    title="문서 일부만 추출되어 사용되었습니다"
                >
                    부분 자료
                </b-badge>
                <small
                    v-if="s.status !== 'used' && s.reason"
                    class="text-muted flex-shrink-0"
                >
                    {{ reasonLabel(s.reason) }}
                </small>
            </li>
        </ul>
        <p v-if="hasUnextractable" class="text-warning small mb-0">
            일부 문서는 내용을 추출할 수 없어 반영되지 않았습니다
            (스캔본·이미지 문서일 수 있습니다).
        </p>
    </div>
</template>

<script>
// 초안 생성 참조 자료(sources) 처리 결과를 표시하는 공용 목록.
// 초안 생성 다이얼로그(완료/실패)와 폼의 적용 안내 alert 세 곳에서 사용한다.
const REASON_LABELS = {
    no_extractable_text: '텍스트를 추출할 수 없음',
    conversion_failed: '문서 변환 실패',
    not_read: 'AI가 참고하지 않음',
};

export default {
    name: 'DraftSourcesList',
    props: {
        sources: { type: Array, default: () => [] },
    },
    computed: {
        hasUnextractable() {
            return this.sources.some(
                (s) => s.status === 'skipped' && s.reason === 'no_extractable_text',
            );
        },
    },
    methods: {
        reasonLabel(reason) {
            return REASON_LABELS[reason] || '반영되지 않음';
        },
    },
};
</script>
